/* global Promise */
import angular from 'angular';
import * as R from 'ramda';

export default function BulkSubmitProcessesDialogController(
  $rootScope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  praDataService
) {
  const vm = this;

  vm.hasData = false;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkSubmit = _handleBulkSubmit;

  vm.handleSelectProcessChange = _handleSelectProcessChange;
  vm.handleSelectAll = _handleSelectAll;

  _activate();

  // //////// METHODS //////////

  function _activate() {  
    if (vm.processes.length > 0) {
      vm.hasData = true;
    }

    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.bulkSubmitProcessesDialog);
  }

  function _handleSelectProcessChange() {
    const selectedIds = [];

    R.forEach((item) => {
      if (item.isSelected === true) {
        selectedIds.push(item.processId);
      }
    }, vm.processes);

    vm.submitIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.processes.length;
  }
  
  function _handleSelectAll() {
    R.forEach((item) => {
      item.isSelected = vm.selectAll;
    }, vm.processes);
      
    vm.submitIsSelected = vm.selectAll;
  } 

  function _handleBulkSubmit() {
    loaderService.showViewLoader = true;
    const bulkSubmitProcessIds = [];

    // Find selections
    angular.forEach(vm.processes, (process) => {
      if (process && process.isSelected) {
        bulkSubmitProcessIds.push(process.assessmentProcessId);
      }
    });

    // Stop if no selections
    if (bulkSubmitProcessIds.length <= 0) {
      vm.isSelected = false;
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }
    // Reset selected
    return praDataService.bulkSubmitAssessmentProcesses(vm.assessmentId, bulkSubmitProcessIds).then(() => {
      alerts.success('The Processes have been Submitted successfully.');
      _handleCloseDialog();
      loaderService.showViewLoader = false;
      $rootScope.$broadcast('refreshPRAAssessments');
    },
    () => {
      alerts.error('There was an error while attempting to Submit the Processes.');
      loaderService.showViewLoader = false;
    });
  }
}

BulkSubmitProcessesDialogController.$inject = [
  '$rootScope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService'
];
